import React from 'react'
import { withPrefix } from 'gatsby'
// Custom Fork
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

// @note[refactor] Swap for imageDetail
const ImageBackgroundDetail = ({
  withPageStyles = false,
  imageDetailDesktop, // eslint-disable-line no-unused-vars
  imageDetailMobile, // eslint-disable-line no-unused-vars
  imageDetailPlaceholder,
  imageDetailTablet, // eslint-disable-line no-unused-vars
}) => {
  return (
    <LazyLoadImage
      wrapperClassName={
        withPageStyles
          ? 'cardInside cardInside__pageLayout card--inside card--detail'
          : 'cardInside cardInside-__foty_redesign card--inside card--detail'
      }
      delayTime={0}
      delayMethod="throttle"
      effect="blur"
      height="100%"
      placeholderSrc={withPrefix(imageDetailPlaceholder)}
      sizes="(max-width: 800px) 100vw, 760px"
      src={withPrefix(imageDetailDesktop)}
      srcSet={`
        ${withPrefix(imageDetailMobile)} 375w, ${withPrefix(
        imageDetailTablet
      )} 760w, ${withPrefix(imageDetailDesktop)} 1520w
      `}
      style={{
        left: '0',
        marginBottom: '0',
        objectFit: 'cover',
        position: 'absolute',
        top: '0',
        zIndex: '4',
      }}
      threshold={0}
      useIntersectionObserver={true}
      visibleByDefault={false}
      width="100%"
    />
  )
}

export default ImageBackgroundDetail
